import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { BonusRecord } from './pages/BonusRecord/BonusRecord';
import { BonusRecordDetail } from './pages/BonusRecordDetail/BonusRecordDetail';

export const BonusRecordRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.BONUS_RECORD} exact={true} component={BonusRecord} />
      <Route path={ROUTES.BONUS_RECORD_DETAIL} component={BonusRecordDetail} />
    </Switch>
  );
};
